import { Component, Emit, Prop, Vue } from "vue-property-decorator";
import Loading from '@/components/Loading.vue';
import ProgressRing from '@/components/ProgressRing.vue';

@Component({ components: { Loading, ProgressRing } })

export default class UploadButton extends Vue {
	@Prop() public title!: string;
	@Prop() public path!: string;
	@Prop() public disabled!: boolean;
	@Prop() public uploading!: boolean;
	@Prop() public progress!: number;
	@Prop() public progressing!: boolean;
	// lifecycle event
	public created(): void { }

	@Emit("uploadButton-click")
	public inputClick() { }
	@Emit("uploadButton-input-change")
	public inputChange(fileList: FileList, path: string) { }

	private onInputClick(): void {
		this.inputClick();
	}

	private onInputChange(e: Event): void {
		const input: HTMLInputElement = e.target as HTMLInputElement;
		const files: FileList | null = input.files;
		if (files === null) {
			return;
		}
		this.inputChange(files, this.path);
		// 同じファイルを続けて選択可能にする
		input.value = '';
	}
}
